// extracted by mini-css-extract-plugin
export default {"emptyTableOverlay":"EmptyTable_emptyTableOverlay__h+Z6p","positionRelative":"EmptyTable_positionRelative__0-VdG"};